// @flow

let instance;

export function getGooglePayClientInstance(): ?GooglePayPaymentsClient {
  if (!instance) {
    instance = getGooglePayClient();
  }
  return instance;
}

function getGooglePayClient(): ?GooglePayPaymentsClient {
  if (hasGooglePaySupport()) {
    return new window.google.payments.api.PaymentsClient({
      environment: ENV_CONSTANTS.ENV === 'production'
        ? 'PRODUCTION'
        : 'TEST',
    });
  }

  if (ENV_CONSTANTS.ENV === 'test') {
    logGooglePayMockWarningMessage();
  }

  return null;
}

function hasGooglePaySupport(): bool {
  return Boolean(
    window.google &&
    window.google.payments &&
    window.google.payments.api &&
    window.google.payments.api.PaymentsClient
  );
}

function logGooglePayMockWarningMessage() {
  // eslint-disable-next-line no-console
  console.warn(`Dear developer, you are trying to execute a test that uses the Google Pay Client.
Please include the following snippet in your test (immediately after the imports) in order to mock it:
\tjest.mock('@tectonics/prs/google-pay/get-client.js');
`);
}
